import SharedWithMePage from "pages/SharedWithMePage";
import React from "react";

const SharedWithMeRoute = () => <SharedWithMePage />;

export default SharedWithMeRoute;
